<template>
  <div class="Maxbox">
    <div class="content">
      <div class="bady">
        <div class="imgs"><img src="./images/submit.png" alt="" /></div>
        <div class="title">你已提交成功</div>
        <div class="btn">
          <button class="bbb" @click="goSas()">查看报告</button>
          <button class="aaa" @click="goCarrerpostion()">返回测评列表</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { GetScaleQuestions, CustomBusScale } from "@/api/home";
export default {
  name: "XTsubmit",

  data() {
    return {
      scaleId: 0,
      id: 0,
    };
  },

  mounted() {
    this.scaleId = this.$route.query.scaleId || 0;
  },

  methods: {
    goCarrerpostion(){
      this.$router.push('/carrerpostion')
    },
    goSas() {
      if (this.scaleId === 0) {
        let routeData = this.$router.resolve({
          path: "/SasAnxiety",
          query: { CustomScaleId: this.$route.query.id },
        });
        window.open(routeData.href, "_blank");
      }
      if (this.scaleId === "339917685502021") {
        let routeData = this.$router.resolve({
          path: "/synthesize",
          query: {
            id: this.$route.query.id,
            createTime: this.$route.query.createTime,
          },
        });
        window.open(routeData.href, "_blank");
      }

      if (this.scaleId == "339926424055877") {
        let routeData = this.$router.resolve({
          path: "/StyleAnxiety",
          query: { id: this.$route.query.id },
        });
        window.open(routeData.href, "_blank");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.Maxbox {
  width: 100%;
  height: 1045px;
  background-color: #fff;
  min-width: 1050px;
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 80%;
    padding-top: 25px;
    padding: 25px 40px 0 30px;
    .bady {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .imgs {
        width: 92px;
        height: 92px;
        img {
          width: 100%;
        }
      }
      .title {
        margin-top: 34px;
        margin-bottom: 114px;
        font-size: 18px;
        color: #333;
      }
      .btn {
        display: flex;
        align-items: center;
        .bbb {
          cursor: pointer;
          width: 150px;
          height: 52px;
          background: #3964e6;
          border-radius: 3px 3px 3px 3px;
          opacity: 1;
          color: #fff;
          font-size: 20px;
          text-align: center;
          line-height: 42px;
          border: 0;
          margin-right: 50px;
        }
        .aaa {
          cursor: pointer;
          width: 200px;
          height: 52px;
          background: #f5f5f5;
          border-radius: 5px 5px 5px 5px;
          opacity: 1;
          border: 1px solid #999;
          color: #fff;
          font-size: 20px;
          text-align: center;
          line-height: 42px;
          color: #666;
        }
      }
    }
  }
}
</style>